import {UserReferral, UserReferralLeaderBoard} from "./user-referral";

export class UserReferralMapper {
  public static map(data: any): UserReferralMapper {
    let userReferral: UserReferral = new UserReferral();
    userReferral.activeCredits = data.active_credits ? data.active_credits : 0;
    userReferral.activeReferrals = data.active_referrals ? parseInt(data.active_referrals, 10) : 0;
    userReferral.appliedCredits = data.applied_credits ? data.applied_credits : 0;
    userReferral.appliedReferrals = data.applied_referrals ? parseInt(data.applied_referrals, 10) : 0;
    userReferral.pendingCredits = data.pending_credits ? data.pending_credits : 0;
    userReferral.pendingReferrals = data.pending_referrals ? parseInt(data.pending_referrals, 10) : 0;
    userReferral.creditsPerReferral = data.credits_per_referral ? data.credits_per_referral : 0;
    userReferral.referralHash = data.referral_hash;
    return userReferral;
  }

}

export class UserReferralLeaderBoardMapper {
  public static map(data: any, index: number): UserReferralLeaderBoardMapper {
    let userReferralLeaderBoard: UserReferralLeaderBoard = new UserReferralLeaderBoard();
    userReferralLeaderBoard.index = index;
    userReferralLeaderBoard.allReferrals = data.all_referrals ? data.all_referrals : 0;
    userReferralLeaderBoard.appliedCredits = data.applied_credits ? data.applied_credits : 0;
    userReferralLeaderBoard.appliedReferralsCount = data.applied_referrals_count ? data.applied_referrals_count : 0;
    userReferralLeaderBoard.activeCredits = data.credits ? data.credits : 0;
    userReferralLeaderBoard.id = data.id ? data.id : 0;
    userReferralLeaderBoard.name = data.name ? data.name : '';
    userReferralLeaderBoard.pendingCredits = data.pending_credits ? data.pending_credits : 0;
    userReferralLeaderBoard.pendingReferralsCount = data.pending_referrals_count ? data.pending_referrals_count : 0;
    userReferralLeaderBoard.activeReferralsCount = data.referrals_count ? data.referrals_count : 0;

    return userReferralLeaderBoard;
  }


}
